import React, {Component} from 'react';
import Select from 'react-select';
import StaticFunctions from "../utils/StaticFunctions";


class CompanySelector extends Component {

    constructor(props) {

        super(props);

        let initCurrentCompany = this.props.Companies.getCurrentCompany();

        if (initCurrentCompany === null && props.baseData && props.baseData.userData.initialized) {
            initCurrentCompany = props.baseData.userData.idCompany;
        }

        this.state = {
            currentCompany: initCurrentCompany
        };

        this.translate = this.props.baseData.translate;

        this.companyChange = this.companyChange.bind(this);

    }

    companyChange(val) {

        this.props.Companies.setCurrentCompany(val ? val.value : null);
        this.props.SetCurrentCompany(val ? val.value : null);

        this.saveSettings = this.props.baseData.saveSettings;

        this.setState({
            currentCompany: this.props.Companies.getCurrentCompany()
        }, () => {
            this.saveSettings('remove', 'reports');
        });

    }

    getOptions() {

        const opt = [];
        const sc = this.props.Companies ? this.props.Companies.getAllCompanies('name', 'asc') : [];
        const cc = this.props.Companies ? this.props.Companies.getCurrentCompany() : null;

        for (let ix in sc) {
            let c = sc[ix];

            opt.push({
                value: String(c.id),
                label: c.name + ' (' + c.id + ')'
            })
        }

        // Ensure current company is in options, even if it's the "Global" dummy (id: 0)
        if (cc && !opt.find(o => o.value === String(cc.id))) {
            opt.push({
                value: String(cc.id),
                label: (cc.name || 'Global') + ' (' + cc.id + ')'
            });
        }

        return opt;

    }

    render() {

        const cc = this.props.Companies ? this.props.Companies.getCurrentCompany() : null;
        const ccId = cc ? String(cc.id) : '';
        const opts = this.getOptions();
        const sortedOpts = StaticFunctions.getSortedData(opts, 'label', 'string');
        const disabled = (sortedOpts.length === 1);

        const selectedOption = sortedOpts.find(o => o.value === ccId) || null;

        return (
            <Select
                name={"form-field-name"}
                className={"chosen-container chosen-container-single"}
                style={{width: '260px'}}
                options={sortedOpts}
                onChange={this.companyChange}
                placeholder={this.translate('select') + '...'}
                value={selectedOption}
                disabled={disabled}
                clearable={false}
                noResultsText={this.translate('noResultsFound')}
            />
        );

    }

}

export default CompanySelector;